import { styled } from "@mui/system"
import { rem } from "polished"
import { Box } from "@mui/material"

const StyledLayout = styled(Box)({
  padding: `${rem(0)}`,
})

export { StyledLayout }
